module.exports = __webpack_public_path__ + "img/system5.2d9f584f.png";